import { Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { environment } from './../environments/environment';

import { DecimalPipe, formatNumber } from "@angular/common";
import { CorporateService } from "./../services/corporate.service";
import { HttpClientModule, HttpClient } from '@angular/common/http';

import Swal from 'sweetalert2';
import {
  floatWith2Decimals,
  groupBy,
  sumBy,
  adjustWith2DecimalsForUI,
} from "./../commonfunctions/commonFunction";
import { SharedService } from '../shared/shared.service';
import { strings } from '../../assets/languageStrings';

@Component({
  selector: 'app-corporatepayment',
  templateUrl: './corporatepayment.component.html',
  styleUrl: './corporatepayment.component.scss',
  encapsulation: ViewEncapsulation.None,
  providers: [DecimalPipe],

})

export class CorporatepaymentComponent implements OnInit {

  public paymentSucessResponse: boolean = false;
  public paymenttransactionResponse: boolean = false;

  public subscriptiondetails: any;
  public visible = false;
  public showbuttons = false
  public lang: any = {};
  selectedLanguage: any;
  languageData: any;
  public countries = []
  public plansummary: any
  public plansummaryMain: any;
  public plansummaryLIFE: any;
  public optplansummary: any;
  public provisioning: any = false;
  public currency: any;
  public currencySymbol: any;
  public uploadfile: any;
  public demovalue: any;
  public responsevalue: any;
  public failedarray: any = []
  customerLink: any;
  ShowModelPopup = false;
  ShowModelPopupTitle: any;
  ShowModelPopupMessage: any;
  showEnrollmentModel = false
  showHeaderMessage: any
  showModelContent: any
  iafgPlansAvailability: boolean = false;
  plansummaryLIFEFinal: any = [];
  isNhlaa: any = false;
  constructor(private http: HttpClient, private CorporateService: CorporateService, private Shared: SharedService, private _sanitizer: DomSanitizer, public router: Router, private route: ActivatedRoute, private _decimalPipe: DecimalPipe) { }

  ngOnInit() {
    this.getLanguageTokens()
    sessionStorage.setItem("pageName", "Signup Process");
    this.postAnalyticsData();
    setInterval(() => {
      this.postAnalyticsData();
    }, 30000);



    this.uploadfile = this.Shared.getMessage()
    this.subscriptiondetails = sessionStorage.getItem("subscriptionresult")


    this.route.queryParams.subscribe(params => {




      if (sessionStorage.getItem("paymentMethod") == "CC") {


        if (params["success"] == "True") {

          this.paymenttransactionResponse = true
          this.visible = true
          this.showbuttons = false

        }
        else {
          this.paymenttransactionResponse = true
          this.visible = true

          this.showbuttons = false
          this.failedarray.push("CCFailed")

          sessionStorage.setItem("failed", JSON.stringify(this.failedarray))


        }


      }

      else {
        this.paymenttransactionResponse = true
        this.visible = true

        this.showbuttons = false
      }



      let personalInfo = JSON.parse(sessionStorage.getItem("Data") || '{}')
      let customerId = sessionStorage.getItem("customerId")
      // let publicApiKey  =JSON.parse(sessionStorage.getItem("publicApiKey"))

      let billingpostalcode = sessionStorage.getItem("billingpostalcode")
      let billingprovincelist = sessionStorage.getItem("billingprovincelist")
      let billingaddresscity = sessionStorage.getItem("billingaddresscity")
      let addressline2 = sessionStorage.getItem("addressline2")
      let addressline1 = sessionStorage.getItem("addressline1")
      // this.paymentSucessResponse = true


      let billingAddressData = {}

      if (sessionStorage.getItem("homeAddress") == "true") {

        billingAddressData = {}

      }
      else {
        billingAddressData = JSON.parse(sessionStorage.getItem("billingAddress") || '{}')

      }

      let bankdetailsobj = sessionStorage.getItem("bankDetails")

 

      this.countries = JSON.parse(sessionStorage.getItem("countrydetails") || "[]")

      this.countries.forEach((element: any) => {
        this.currency = element.currency
        this.currencySymbol = element.currencySymbol
      })

      let summary = JSON.parse(sessionStorage.getItem("plansummary") || '[]')
      var formData: any = new FormData();



      let plans: any = []




      this.plansummaryMain = JSON.parse(sessionStorage.getItem("allSelectedPlans") || '[]')
      // this.plansummaryMain = JSON.parse(sessionStorage.getItem("plansummarymain")||'')
      let plansummaryMainforoptions: any = JSON.parse(sessionStorage.getItem("plansummarymain") || "[]");
      if (plansummaryMainforoptions && plansummaryMainforoptions.length > 0) {
        this.plansummaryMain.forEach((element: any) => {
          let options_: any = plansummaryMainforoptions.find((item: any) => item.id == element.id)?.options ?? [];
          element.options = options_
        })
      }

      this.plansummaryLIFE = JSON.parse(sessionStorage.getItem("planssummarymainLife") || '[]')
      let planDetailsArrayBlock = JSON.parse(sessionStorage.getItem("planssummarymainLife") || '[]')



      this.plansummaryLIFE.forEach((element: any, index: number) => {

        element.member.maximumCoverageWithoutEvidence = element.member.defaultRange

        if (element.spouse && element.spouse.maximumCoverageWithoutEvidence) {
          element.spouse.maximumCoverageWithoutEvidence = element.spouse.defaultRange

        }
        element['amount'] = element.guaranteedAcceptanceDetails.amount
        element['amountUI'] = "$" + element.guaranteedAcceptanceDetails.amount
        element['planPrice'] = element.guaranteedAcceptanceDetails.amount
        element['total'] = element.guaranteedAcceptanceDetails.total
        element['totalPrice'] = element.guaranteedAcceptanceDetails.total
        element['skuTotalPrice'] = element.guaranteedAcceptanceDetails.total
        element['totalUI'] = "$" + element.guaranteedAcceptanceDetails.total
        element['tax'] = element.guaranteedAcceptanceDetails.tax
        element['taxUI'] = "$" + element.guaranteedAcceptanceDetails.tax
        this.plansummaryLIFEFinal.push(element)

      });
      planDetailsArrayBlock.forEach((element: any, index: number) => {
        if (element.id == 13) {
          this.iafgPlansAvailability = true
        }
        else {
          this.iafgPlansAvailability = false
        }

      });

      this.plansummary = this.plansummaryMain.concat(this.plansummaryLIFEFinal)

      // this.plansummary =this.plansummaryMain.concat(this.plansummaryLIFE)
      // this.optplansummary = JSON.parse(sessionStorage.getItem("allSelectedOptPlans"))
      this.plansummary = this.plansummary.sort(function (a: any, b: any) {
        return (a.packageId - b.packageId);
      })
      console.log(this.plansummary)
      let taxesInfo = {}
      this.plansummary.forEach((element: any) => {

        if (element.packageId == 1) {
          this.provisioning = true
        }

        // Snapshot the real per-tax-type breakdown BEFORE the planGrandTotal block below
        // stamps the plan level total onto every planProductInfo. With payroll deduction NO
        // planGrandTotal holds the company base share, so reading the taxes afterwards gives
        // every tax type the same (base share) amount instead of its own value.
        const taxBreakdown = this.buildTaxBreakdown(element);

        // add some conditions
        if (element?.planGrandTotal && Object.keys(element.planGrandTotal).length > 0) {
          const { total, tax } = element.planGrandTotal;

          if (element.products?.length > 0) {
            element.products.forEach((product: any) => {
              if (product?.calculatedTax?.planProductInfos?.length > 0) {
                product.calculatedTax.total = total;
                product.calculatedTax.tax = tax;

                product.calculatedTax.planProductInfos.forEach((planProductInfo: any) => {
                  if (planProductInfo) {
                    planProductInfo.componentTax = tax;
                    planProductInfo.componentTotal = total;
                    planProductInfo.price = tax;
                  }
                });
              }

              if (product) {
                product.total = total;
                product.tax = tax;
              }
            });
          }
        }

        element.totalPrice = this._decimalPipe.transform(element.totalPrice, "1.2-2")?.replace(/,/g, "")
        element.total = this._decimalPipe.transform(element.totalPrice, "1.2-2")?.replace(/,/g, "")
        element.tax = this._decimalPipe.transform(element.tax, "1.2-2")?.replace(/,/g, "")
        element.amount = this._decimalPipe.transform(element.amount, "1.2-2")?.replace(/,/g, "")
        element.planLevelName = element.groupName
        taxesInfo = this.determineTaxes(element?.products?.[0]?.calculatedTax?.planProductInfos ?? [])
        element.taxApplicable = element.tax > 0
        Object.assign(element, taxesInfo);

        // determineTaxes only reads products[0] and never fills qst / the *Check / *Price
        // fields, so restate all twelve tax fields from the snapshot taken above.
        this.applyTaxBreakdown(element, taxBreakdown);

        if(element.planLevel == 15){
            let multiPlanCount = JSON.parse(sessionStorage.getItem("multiPlanCount") ?? "0");
            if (multiPlanCount > 0) {
              let planScopeDetails = JSON.parse(sessionStorage.getItem("planScopeDetails") ?? "[]");
              element.count = multiPlanCount
              element.planScopeDetails = planScopeDetails
            }
          }


          if(element.companyCoveredBasePlan && element.companyCoveredBasePlan.products && element.companyCoveredBasePlan.products.length > 0){
            // element.companyCoveredBasePlan.products.filter((item:any) => Object.keys(item).filter((key:any) => key != "data"));
          }


          if(element.id == 908){
            let questionnarireRaw = sessionStorage.getItem("allstate_questionnaire");
            let recordedQuestionnarireRaw = sessionStorage.getItem("recordedData");

            if(questionnarireRaw){
              let questionnarire = JSON.parse(questionnarireRaw ?? "{}");
              let finalObj:any = {};

              let objkeys = Object.keys(questionnarire.answers);
              for(const key_ of objkeys){
                if(!finalObj[key_]){
                  finalObj[key_] = questionnarire.answers[key_]['value']
                }
              }
               element.allstateQuestionnaire = finalObj
            }

             if(recordedQuestionnarireRaw){
              let questionnarire = JSON.parse(recordedQuestionnarireRaw ?? "{}");
              let finalObj:any = {};

              let objkeys = Object.keys(questionnarire.userAnswers);
              for(const key_ of objkeys){
                if(!finalObj[key_]){
                  finalObj[key_] = questionnarire.userAnswers[key_]['value']
                }
              }
              //  element.recordedAllstateQuestionnaire = finalObj
               element.allstateQuestionnaire = finalObj
               element.userOptedCoverage = questionnarire?.userOptedCoverage ?? 50000
            }
          }
          
          plans.push(element)
      });


      console.log("plans1232: ", plans)
      // plans.concat(this.optplansummary)


      let employeeKey = sessionStorage.getItem("employeelink");
      let employeeGeneric;

      if (employeeKey && employeeKey != "undefined") {
        employeeGeneric = false

      } else {
        employeeGeneric = true

      }


      formData.append("plans", JSON.stringify(plans));
      formData.append("customerId", parseInt(sessionStorage.getItem("customerId") || '0'));
      formData.append("fusebill_customerId", parseInt(sessionStorage.getItem("fusebillCustomerId") || '0'));
      formData.append("fusebill_paymentMethodId", parseInt(params["paymentMethodId"]) || 0);

      formData.append("enrollmentDate", sessionStorage.getItem("enrollmentdate"));
      formData.append("add_address_toTaxation", false);
      formData.append("totalAmount", sessionStorage.getItem("totalAmountUI")?.replace('$', '') || sessionStorage.getItem("totalAmount"));

      //  formData.append("plans",);
      formData.append("currency", "CAD");
      formData.append("currencySymbol", "$");

      formData.append("totalAmountUI", sessionStorage.getItem("totalAmountUI"));
      formData.append("stateId", parseInt(sessionStorage.getItem("stateid") || '1'));
      formData.append("signature", sessionStorage.getItem("signature") || "");

      formData.append("timestamp", new Date().getTime());

      formData.append("customerTierId", sessionStorage.getItem("customerTierId") ? parseInt(sessionStorage.getItem("customerTierId") || '1') : 1 || 1);

      formData.append("payrollDeduction", sessionStorage.getItem("payrollDeduction") ?  sessionStorage.getItem("payrollDeduction") == "NO" ? false : true  : true)
      formData.append("corporateStateId", sessionStorage.getItem("companyStateId"))
      formData.append("employeeWorkingStateId", sessionStorage.getItem("corporateStateId"))

      formData.append("firstName", personalInfo?.firstName);
      formData.append("lastName", personalInfo?.lastName);
      formData.append("email", personalInfo?.email);
      formData.append("userKey", sessionStorage.getItem("userKey"));
      formData.append("employeeGeneric", employeeGeneric);
      formData.append("iafgPlansAvailability", this.iafgPlansAvailability);








      if (sessionStorage.getItem("paymentMethod") == "CC") {
        formData.append("fusebill_paymentMethod", sessionStorage.getItem("paymentMethod"));


      } else if (sessionStorage.getItem("paymentMethod") == "PAD") {
        formData.append("padFilename", sessionStorage.getItem("filename") + ".pdf");
        formData.append("session", sessionStorage.getItem("session")) || "";
        formData.append("files", this.uploadfile) || "";
        formData.append("fusebill_paymentMethod", sessionStorage.getItem("paymentMethod"));

      }
      else {
        formData.append("fusebill_paymentMethod", "NONE");


      }




      //this.consoleMessage(formData)

      // if(sessionStorage.getItem("Demoform")=="true"){
      //   this.demovalue="test/ROE"
      // }
      // else{
      //   this.demovalue="v2/subscription"
      // }


      let multiPlanCount = JSON.parse(sessionStorage.getItem("multiPlanCount") ?? "0");
      if (multiPlanCount > 0) {
        let planScopeDetails = JSON.parse(sessionStorage.getItem("planScopeDetails") ?? "[]");
        formData.append("count", multiPlanCount)
        formData.append("planScopeDetails", planScopeDetails)
      }


      let nhlaaSignup = JSON.parse(sessionStorage.getItem("isNhlaaSignup") ?? "false");
      this.isNhlaa = nhlaaSignup;

      if (sessionStorage.getItem('paymentPlatform') == 'AuthorizeNet') {
        this.demovalue = "v5/subscription"
        if(nhlaaSignup){
          this.demovalue = "generic/v5/subscription"
          let hidePlanCategorization = JSON.parse(sessionStorage.getItem("hidePlanCategorization") ?? "false");
          let hideCompanyPaidPlans = JSON.parse(sessionStorage.getItem("hideCompanyPaidPlans") ?? "false");
          let coveragesOverride = JSON.parse(sessionStorage.getItem("coveragesOverride") ?? "false");
          formData.append('hidePlanCategorization', hidePlanCategorization)
          formData.append('hideCompanyPaidPlans', hideCompanyPaidPlans)
        }
        formData.append('taxes', [])
        formData.append('paymentPlatform', 'AuthorizeNet')
        let authorizeNetPaymentProfileId = sessionStorage.getItem('authorizenetPaymentId')
        if (!!authorizeNetPaymentProfileId && authorizeNetPaymentProfileId != 'null' && authorizeNetPaymentProfileId != 'undefined') {
        } else {
          authorizeNetPaymentProfileId = '';
        }
        formData.append('authorizeNetCustomerProfileId', sessionStorage.getItem('authorizenetCustomerId'))
        formData.append('authorizeNetPaymentProfileId', authorizeNetPaymentProfileId)
        formData.append('customerPaymentMethod', sessionStorage.getItem('paymentMethod') == 'CC' ? 'CC' : sessionStorage.getItem('paymentMethod') == 'PAD' ? 'PAD' : '')// defeault CC

        // remove session storage values
        // sessionStorage.removeItem('authorizenetCustomerId')
        // sessionStorage.removeItem('authorizenetPaymentId')
        // sessionStorage.removeItem('payment')
      } else {
        this.demovalue = "v4/subscription"
      }

      let activity: any = {};
      activity.action = 'Step 7 of 7 - Customer subscription';
      activity.url = environment.app.grp + "api/corporate/customer/" + this.demovalue;
      activity.requestMethod = 'POST';
      activity.effectedUserId = customerId;
      activity.requestBody = JSON.stringify(formData);

      if (customerId == '0') {
        // Swal.fire({title:'Info',text:'Invalid customer ID'})

        activity.status = 'FAILURE';
        activity.response = {};
        activity.responseSummary = 'Found customer id as 0';
        // this.CorporateService.buildActivityLogObject(activity, true);

        let log = {
          api: environment.app.grp + "api/corporate/customer/" + this.demovalue,
          payload: JSON.stringify(formData),
          message: `Found customer Id as 0`,
          portal: 'Corporate Signup form'
        }
        let obj = {
          customerDetails: JSON.stringify({ username: personalInfo?.email, timeStamp: sessionStorage.getItem('timeStamp') }),
          logs: JSON.stringify(log),
        };
        this.CorporateService.submitReportLog(environment.app.commonurl, obj);

        this.ShowModelPopup = true
        this.ShowModelPopupMessage = 'Sorry for the inconvenience! An unexpected error occurred. Your information is safely stored, we will contact you once it got resolved.';
        this.ShowModelPopupTitle = 'Error';
        return;
      }

      var requestOptions: any = {

        method: 'POST',
        body: formData,
        redirect: 'follow'

      };

      if (!sessionStorage.getItem("subscriptionCalled") || sessionStorage.getItem("subscriptionCalled") != "1") {
        sessionStorage.setItem("subscriptionCalled", "1")

        fetch(environment.app.grp + "api/corporate/customer/" + this.demovalue + "", requestOptions)

          .then(response => response.text())

          .then((resposne: any) => {
            //this.consoleMessage(resposne)
            resposne = JSON.parse(resposne)
            //this.consoleMessage(resposne.status)
            if (resposne.status == 200) {

              activity.status = 'SUCCESS';
              activity.response = resposne;
              activity.responseSummary = 'Customer subscription successful';
              // this.CorporateService.buildActivityLogObject(activity, true);

              this.customerLink = resposne.customerPortalLink

              this.paymenttransactionResponse = false
              this.paymentSucessResponse = true
              this.visible = false
              this.provisioning = false
              this.showbuttons = true
              this.paymenttransactionResponse = false
              this.paymentSucessResponse = true

              this.subscriptiondetails = resposne.data
              if (sessionStorage.getItem("Demoform") == "true") {
                this.responsevalue = resposne.message + "<br>" + resposne.data

              }
              else {

                this.responsevalue = "Thank you for your enrollment! Please check your inbox for the welcome email. Log in to your Member Portal and set your password."

                // this.responsevalue=`Thank you for your enrollment!  Please check your inbox for your welcome email. Login to your Member Portal using the activation code in the welcome email and update the password.`
                // this.responsevalue =this.lang.Thank_you_for_your_enrollment_Please_check_your_inbox_for_your_welcome_email_Login_to_your_Member_Portal_using_the_activation_code_in_the_welcome_email_and_update_the_password
                // this.responsevalue="Thank you for applying for coverage with us. You will receive your booklet/card (if applicable) and instructions on accessing your program 3-5 days before your coverage begins."
              }
              this.showEnrollmentModel = true
              this.showHeaderMessage = this.lang.Enrollment_successful ?? 'Enrollment successful'
              this.showModelContent = this.responsevalue

              // sessionStorage.clear()
              // sessionStorage.removeItem("subscriptionCalled")

            }

            else {
              this.paymenttransactionResponse = false
              this.visible = false
              this.showEnrollmentModel = true
              this.showHeaderMessage = this.lang.Enrollment_successful ?? 'Enrollment successful'
              this.showModelContent = this.responsevalue

              // sessionStorage.clear()
              // sessionStorage.removeItem("subscriptionCalled")

              activity.status = 'FAILURE';
              activity.response = resposne;
              activity.responseSummary = 'Customer subscription failed';
              // this.CorporateService.buildActivityLogObject(activity, true);

            }

          })
          .catch(error => {
            //this.consoleMessage('error', error)
            if ([0, 500, 501, 502, 503].includes(error.status)) {
              this.ShowModelPopup = true
              this.ShowModelPopupMessage = this.lang?.Sorry_the_server_is_currently_undergoing_maintenance_Please_try_again_later_We_apologize_for_any_inconvenience ?? 'Sorry, the server is currently undergoing maintenance. Please try again later. We apologize for any inconvenience.'
              this.ShowModelPopupTitle = this.lang?.Info ?? 'Info'

              activity.status = 'FAILURE';
              activity.response = error;
              activity.responseSummary = 'Customer subscription failed';
              // this.CorporateService.buildActivityLogObject(activity, true);

              // create object for report log
              let currentTimeStamp = new Date().getTime().toString();
              let log = {
                api: environment.app.grp + "api/corporate/customer/" + this.demovalue + "",
                payload: JSON.stringify(formData),
                message: this.lang?.Sorry_the_server_is_currently_undergoing_maintenance_Please_try_again_later_We_apologize_for_any_inconvenience ?? 'Sorry, the server is currently undergoing maintenance. Please try again later. We apologize for any inconvenience.' + " " + currentTimeStamp,
                portal: 'Corporate Signup form'
              }

              let obj = {
                customerDetails: JSON.stringify({ username: personalInfo.email, timeStamp: sessionStorage.getItem('timeStamp') }),
                logs: JSON.stringify(log),
              };
              this.CorporateService.submitReportLog(environment.app.commonurl, obj);
            }
            else {

              activity.status = 'FAILURE';
              activity.response = error;
              activity.responseSummary = 'Customer subscription failed';
              // this.CorporateService.buildActivityLogObject(activity, true);

              this.ShowModelPopup = true
              this.ShowModelPopupMessage = error.error.message ? error.error.message : error.error.error,
                this.ShowModelPopupTitle = this.lang.Info ?? 'Info'

              // create object for report log
              let currentTimeStamp = new Date().getTime().toString();
              let log = {
                api: environment.app.grp + "api/corporate/customer/" + this.demovalue + "",
                payload: JSON.stringify(formData),
                message: `Error in subscription form ${currentTimeStamp}`,
                portal: 'Corporate Signup form'
              }

              let obj = {
                customerDetails: JSON.stringify({ username: personalInfo.email, timeStamp: sessionStorage.getItem('timeStamp') }),
                logs: JSON.stringify(log),
              };
              this.CorporateService.submitReportLog(environment.app.commonurl, obj);
            }
          });


      }
      else {
        this.paymenttransactionResponse = false
        this.visible = false
        this.provisioning = false

        this.ShowModelPopup = true
        this.ShowModelPopupMessage = this.lang.You_are_already_done_with_the_subscription_Please_check_your_mail_or_contact_admin_groupbenefitz_ca ?? 'You are already done with the subscription.Please check your mail or contact admin@groupbenefitz.ca',
          this.ShowModelPopupTitle = this.lang.Info ?? 'Info'

        // create object for report log
        let currentTimeStamp = new Date().getTime().toString();
        let log = {
          api: environment.app.grp + "api/corporate/customer/" + this.demovalue + "",
          payload: JSON.stringify(formData),
          message: `Trying to submit subscription form again ${currentTimeStamp}`,
          portal: 'Corporate Signup form'
        }

        let obj = {
          customerDetails: JSON.stringify({ username: personalInfo.email, timeStamp: sessionStorage.getItem('timeStamp') }),
          logs: JSON.stringify(log),
        };
        this.CorporateService.submitReportLog(environment.app.commonurl, obj);
      }

    })



  }

  /**
   * Maps a planProductInfo entry onto one of the four tax buckets.
   * taxSKU is the reliable key ("hst", "pstonhealthinsurance", ...); name/tax are the fallback.
   */
  private resolveTaxBucket(info: any): 'gst' | 'hst' | 'pst' | 'qst' | null {
    const sku = String(info?.taxSKU ?? '').toLowerCase();
    const label = String(info?.tax ?? info?.name ?? info?.fullTaxName ?? '').toUpperCase();

    if (sku.startsWith('qst') || label.includes('QST')) return 'qst';
    if (sku.startsWith('hst') || label.includes('HST')) return 'hst';
    if (sku.startsWith('gst') || label.includes('GST')) return 'gst';
    if (sku.startsWith('pst') || label.includes('PST') || label.includes('PROV')) return 'pst';
    return null;
  }

  /**
   * Sums the tax of every component of every product of the plan, grouped by tax type.
   * This is the combined (company share + employee share) tax, which is what the plan row
   * carries — element.amount / element.total are combined figures too.
   */
  public buildTaxBreakdown(plan: any) {
    const buckets: any = {
      gst: { amount: 0, rate: 0, seen: false },
      hst: { amount: 0, rate: 0, seen: false },
      pst: { amount: 0, rate: 0, seen: false },
      qst: { amount: 0, rate: 0, seen: false },
    };
    const names: string[] = [];

    const infos = (plan?.products ?? []).reduce(
      (acc: any[], product: any) => acc.concat(product?.calculatedTax?.planProductInfos ?? []),
      []
    );

    for (const info of infos) {
      const bucket = this.resolveTaxBucket(info);
      if (!bucket) continue;

      const amount = Number(info?.componentTax ?? info?.price ?? 0);
      const rate = Number(info?.taxRate ?? 0);

      buckets[bucket].seen = true;
      buckets[bucket].amount += isNaN(amount) ? 0 : amount;
      // taxRate arrives as a fraction (0.13); the API expects a percentage (13)
      if (!isNaN(rate) && rate > 0) {
        buckets[bucket].rate = rate <= 1 ? adjustWith2DecimalsForUI(rate * 100) : adjustWith2DecimalsForUI(rate);
      }

      const name = bucket.toUpperCase();
      if (!names.includes(name)) names.push(name);
    }

    for (const key of Object.keys(buckets)) {
      buckets[key].amount = adjustWith2DecimalsForUI(buckets[key].amount);
    }

    return { buckets, taxName: names.join(' | '), hasTaxInfo: names.length > 0 };
  }

  /**
   * Writes the twelve tax fields the subscription API reads. Amount and rate are null when the
   * tax does not apply (matching what determineTaxes already sends for gst/hst/pst), *Check is
   * driven by the amount rather than by whether a value was present in the plan data attribute,
   * and *Price mirrors the amount instead of being left at 0.
   */
  public applyTaxBreakdown(plan: any, breakdown: any) {
    if (!plan || !breakdown) return;

    for (const key of ['gst', 'hst', 'pst', 'qst']) {
      const bucket = breakdown.buckets[key];

      if (breakdown.hasTaxInfo) {
        plan[key] = bucket.seen && bucket.amount > 0 ? bucket.amount : null;
        plan[key + 'TaxRate'] = bucket.seen && bucket.rate > 0 ? bucket.rate : null;
      }

      const amount = Number(plan[key] ?? 0);
      plan[key + 'Check'] = !isNaN(amount) && amount > 0;
      plan[key + 'Price'] = !isNaN(amount) && amount > 0 ? adjustWith2DecimalsForUI(amount) : 0;
    }

    if (breakdown.hasTaxInfo) {
      plan.taxName = breakdown.taxName;
      plan.taxPrice = adjustWith2DecimalsForUI(
        (plan.gst ?? 0) + (plan.hst ?? 0) + (plan.pst ?? 0) + (plan.qst ?? 0)
      );
    }
  }

  public determineTaxes(taxArray: any) {
    let taxObj: any = {
      pst: null,
      pstTaxRate: null,
      hst: null,
      hstTaxRate: null,
      gst: null,
      gstTaxRate: null,
      taxName: null,
      taxPrice: null
    };
    for (let tax of taxArray) {
      if (!taxObj.taxName || taxObj.taxName == null) {
        taxObj.taxName = "";
      }

      if (tax.name.includes("PST") || tax.name.includes("Prov")) {
        taxObj.pst = tax.price + (taxObj.pst ?? 0);
        taxObj.pstTaxRate = (tax.taxRate) * 100
        if (!taxObj.taxName.includes(tax.name))
          taxObj.taxName += tax.name + " | "
      }
      if (tax.name.includes("HST")) {
        taxObj.hst = tax.price + (taxObj.hst ?? 0);
        taxObj.hstTaxRate = (tax.taxRate) * 100
        if (!taxObj.taxName.includes(tax.name))
          taxObj.taxName += tax.name + " | "
      }
      if (tax.name.includes("GST")) {
        taxObj.gst = tax.price + (taxObj.gst ?? 0);
        taxObj.gstTaxRate = (tax.taxRate) * 100;
        if (!taxObj.taxName.includes(tax.name))
          taxObj.taxName += tax.name + " | "
      }
    }
    taxObj.taxName = taxObj.taxName?.trim();
    if (taxObj.taxName && taxObj.taxName[taxObj.taxName.length - 1] == "|") {
      taxObj.taxName = taxObj.taxName.slice(0, -1);
      taxObj.taxName = taxObj.taxName?.trim();
    }

    if (taxObj.pst || taxObj.hst || taxObj.gst) {
      taxObj.taxPrice = 0;
      taxObj.taxPrice = (taxObj.pst ?? 0) + (taxObj.hst ?? 0) + (taxObj.gst ?? 0)
    }

    return taxObj;
  }

  // public getLanguageTokens() {
  //   let body = {
  //     "project": "SignupForm",
  //     "url": "CorporatePayment"
  //   }
  //   this.http
  //     .post(environment.app.langApi + 'string/project-url-strings', body, {
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //     })
  //     .subscribe(
  //       (response: any) => {
  //         console.log(response)
  //         this.lang = {};
  //         this.languageData = response.strings
  //         this.selectedLanguage = sessionStorage.getItem("language")
  //         for (let token of response.strings) {
  //           this.lang[token.key] = token[this.selectedLanguage];
  //         }
  //       })
  // }

  public getLanguageTokens() {
    let body = {
      project: 'SignupForm',
      url: 'CorporatePayment',
    };

    this.http
      .post(environment.app.langApi + 'string/project-url-strings', body, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (!response || !response.strings || response.strings.length === 0) {
            // fallback to local language strings
            this.loadLocalLanguageStrings();
          } else {
            this.setupLanguage(response.strings);
          }
        },
        (error) => {
          // on error, also fallback to local strings
          this.loadLocalLanguageStrings();
        }
      );
  }

  private loadLocalLanguageStrings() {
    this.setupLanguage(strings);
  }

  private setupLanguage(strings: any[]) {
    this.lang = {};
    this.languageData = strings;
    this.selectedLanguage = sessionStorage.getItem("language");

    for (let token of strings) {
      this.lang[token.key] = token[this.selectedLanguage];
    }
  }

  onClosedModelpopup(confirmed: boolean) {
    if (confirmed) {
      this.ShowModelPopup = false;
      this.showEnrollmentModel = false;
    } else {
      this.ShowModelPopup = false;
      this.showEnrollmentModel = false;
    }
  }
  closeModelpopup() {
    this.showEnrollmentModel = false
    if(this.isNhlaa){
      console.log("====nhlaa customer====")
    }else{
      window.open(this.customerLink)
    }

  }
  postAnalyticsData() {
    var pageName = sessionStorage.getItem("pageName");
    if (
      sessionStorage.getItem("ipaddress")
    ) {
      fetch(environment.app.grp + "api/common/analytics", {
        method: "POST",

        body: JSON.stringify({
          ipAddress: sessionStorage.getItem("ipaddress"),
          timestamp: sessionStorage.getItem("timeStamp"),
          pageName: pageName ? pageName : "PersonalInfo",
          gbReferer: window.document.referrer || "",
          pageUrl: window.location.href,
        }),

        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      });
    }
  }
  consoleMessage(...args: any) {
    // console.log(args)
  }
  public gotohomepage() {
    this.router.navigate(['/signup']);
  }

  public printpage() {
    window.print();
  }
}

